export default "__VITE_ASSET__RJnPOFeV__"